import { httpClient } from '../core';
import { env } from '@/env';
import FileSaver from 'file-saver';
declare const Windows: any;

interface FilePreviewResponse {
  previewUrl: string;
  previewToken: string;
}

class TranslationsService {
  public async getFilePreviewUrlAndToken(
    documentId: string,
    target: string
  ): Promise<FilePreviewResponse> {
    try {
      const response: {
        data: FilePreviewResponse;
      } = await httpClient.instance.get(
        `${env.apiUrl}/documents/${env.applicationId}/${documentId}/preview` +
          (target ? `${target}` : ``)
      );
      return response.data;
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error previewing file");
      throw error;
    }
  }

  public getDownloadUrl(documentId: string, target: string) {
    return (
      `${env.apiUrl}/documents/${env.applicationId}/${documentId}/download` +
      (target ? `${target}` : ``)
    );
  }

  public async getFileInfoFromUrl(url: string): Promise<any> {
    const urlEncoded = encodeURIComponent(url);
    try {
      const response = await httpClient.instance.get(
        `${env.apiUrl}/documents/${env.applicationId}/url/size?url=${urlEncoded}`
      );

      return response.data;
    } catch (error) {
      return null;
    }
  }

  public async getFileFromUrl(fileName: string, url: string): Promise<File> {
    try {
      const urlEncoded = encodeURIComponent(url);
      const response = await httpClient.instance.get(
        `${env.apiUrl}/documents/${env.applicationId}/url?url=${urlEncoded}`,
        {
          responseType: "blob",
        }
      );
      response.data.lastModified = new Date().getTime();
      response.data.lastModifiedDate = new Date();
      response.data.name = fileName;

      return new File([response.data], fileName);
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error downloading url file");
      // eslint-disable-next-line
      console.error(error);
      throw error;
    }
  }

  public async downloadFile(
    documentId: string,
    fileName: string,
    target: string
  ): Promise<boolean> {
    try {
      const downloadUrl = this.getDownloadUrl(documentId, target);
      const response = await httpClient.instance.get(downloadUrl, {
        responseType: "blob",
      });

      response.data.lastModifiedDate = new Date();
      response.data.name = fileName;

      let downloaded = true;
      const isUwpApplication =
        typeof Windows !== "undefined" && Windows.Storage;
      if (isUwpApplication) {
        // console.log(Windows.Storage);
        downloaded = await this.downloadFileUwp(response.data, fileName);
      } else {
        FileSaver.saveAs(response.data, fileName);
      }
      return downloaded;
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error downloading file");
      // eslint-disable-next-line
      console.error(error);
      throw error;
    }
  }

  public async downloadFileFromPublicUrl(downloadUrl: string): Promise<File> {
    try {
      // FileSaver.saveAs(downloadUrl);
      const url = new URL(downloadUrl);
      const response = await httpClient.instance.head(downloadUrl, {
        headers: {
          Accept: "*/*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "OPTIONS,HEAD,GET,POST",
          "Access-Control-Allow-Headers":
            "origin, x-requested-with, accept, x-api-key",
          "Strict-Transport-Security":
            "max-age=31536000; includeSubDomains; preload",
        },
      });
      response.data.lastModifiedDate = new Date();
      response.data.name = downloadUrl.substring(
        downloadUrl.lastIndexOf("/") + 1
      );
      return response.data;
    } catch (error) {
      // eslint-disable-next-line
      console.error("Error downloading file");
      // eslint-disable-next-line
      console.error(error);
      throw error;
    }
  }

  private async downloadFileUwp(blob: any, fileName: string): Promise<boolean> {
    const savePicker = new Windows.Storage.Pickers.FileSavePicker();
    savePicker.suggestedStartLocation =
      Windows.Storage.Pickers.PickerLocationId.documentsLibrary;
    const ext = fileName.substr(fileName.lastIndexOf("."));
    savePicker.fileTypeChoices.insert(ext, [ext]);
    savePicker.suggestedFileName = fileName;

    const file = await savePicker.pickSaveFileAsync();
    // console.log(file);

    if (file) {
      // Prevent updates to the remote version of the file until call CompleteUpdatesAsync.
      Windows.Storage.CachedFileManager.deferUpdates(file);
      // write to file
      const output = await file.openAsync(
        Windows.Storage.FileAccessMode.readWrite
      );
      // Copy the stream from the blob to the File stream
      const input = blob.msDetachStream();
      await Windows.Storage.Streams.RandomAccessStream.copyAsync(input, output);
      output.flushAsync().done(() => {
        input.close();
        output.close();
      });
      return true;
    } else {
      return false;
      // Operation cancelled
    }
  }
}

export default new TranslationsService();
